import React from 'react';
import PropTypes from 'prop-types';

import styles from './QuestionDisplay.scss';
import pbStyles from './paperBasedStyles/ceqPBStyles.scss';
import QuestionRubricBlock from './QuestionRubricBlock';
import questionRubricBlockWithTitleSelector from '../../selectors/question/QuestionRubricBlockWithTitleSelector';
import settingsReader from '../../store/readHelpers/SettingsReader';
import questionReader from '../../store/readHelpers/QuestionReader';
import uiService from '../../services/UIService';
import { t } from '../../services/i18nService';
import sessionReader from '../../store/readHelpers/SessionReader';

const QuestionRubricBlockWithTitleContent = (props) => {
    const {
        isSectionLevel,
        question,
        section,
        scorableItemId,
        showRubric,
        showTitle,
        useDynamicRubric,
        questionRubricTitle,
        canvasOpened,
    } = props;

    const classList = ['question-rubric', styles.questionRubricBlock];

    let shouldShowSectionRubricForCEQPaperBased = false;
    let hidePbBasedRubric = false;

    if (uiService.isPaperBasedRenderForCEQ()) {
        hidePbBasedRubric = (question.stimulus !== undefined) ||
        (section.stimulusContent !== undefined);
        if (!hidePbBasedRubric &&
            (questionReader.isFirstQuestionInSection(question))) {
            shouldShowSectionRubricForCEQPaperBased = true;
            classList.push(styles.pbBasedRubricContent);
        }
    }

    if (useDynamicRubric) {
        classList.push(styles.dynamicRubric);
    }

    if (isSectionLevel) {
        classList.push(styles.sectionLevelDynamicRubric);
    }

    if ((!showTitle && !showRubric) || canvasOpened) {
        return null;
    }

    const showBlock = showTitle && !settingsReader.isPciBasedCustomAssessment();
    const showPart = showBlock && uiService.isPaperBasedRenderForCEQ() && shouldShowSectionRubricForCEQPaperBased && !hidePbBasedRubric;
    const showQuestionRubricTitle = showBlock && (!uiService.isPaperBasedRenderForCEQ() || shouldShowSectionRubricForCEQPaperBased);
    const questionRubricTitleClassList = ['scorableItemHeadline'];
    if (shouldShowSectionRubricForCEQPaperBased && uiService.isPaperBasedRenderForCEQ()) {
        questionRubricTitleClassList.push(styles.pbBasedRubricQuestionTitle);
    }

    if (settingsReader.isPBRenderForCeqEnabled() && sessionReader.isPrintStylePaperBased()) {
        questionRubricTitleClassList.push('pb-ceq-rubric-title-no-top-margin');
    }

    const noMarginClassName = settingsReader.isPBRenderForCeqEnabled() && sessionReader.isPrintStylePaperBased()
        ? pbStyles.pbBasedSectionTitleWithNoTopMargin : '';

    return (
        <div className={classList.join(' ')}>
            {showPart && (
                <div className={noMarginClassName}>
                    <h3 className={pbStyles.pbBasedSectionTitleWithNoTopMargin}>{t('generic.Part')} {question.sectionNumber || '1'}</h3>
                </div>
            )}

            {showQuestionRubricTitle && (
                <h3 className={questionRubricTitleClassList.join(' ')} id={scorableItemId}>
                    {questionRubricTitle}
                </h3>
            )}

            { showRubric && <QuestionRubricBlock question={question} hidePbBasedRubric={hidePbBasedRubric} /> }
        </div>);
};

QuestionRubricBlockWithTitleContent.propTypes = {
    isSectionLevel: PropTypes.bool,
    section: PropTypes.object.isRequired,
    question: PropTypes.object.isRequired,
    scorableItemId: PropTypes.string.isRequired,
    showRubric: PropTypes.bool.isRequired,
    showTitle: PropTypes.bool.isRequired,
    useDynamicRubric: PropTypes.bool.isRequired,
    questionRubricTitle: PropTypes.string.isRequired,
    canvasOpened: PropTypes.bool.isRequired,
};

const QuestionRubricBlockWithTitle = props => (
    <QuestionRubricBlockWithTitleContent {...props} {...questionRubricBlockWithTitleSelector.selectProps(props)} />
);

export default QuestionRubricBlockWithTitle;
